import { Component, OnInit } from '@angular/core';
import { LocalStorage } from 'src/app/core/localstorage';
import { TokenService } from 'src/app/core/services/token.service';
import { UserService } from '../../user/user.service';

@Component({
    selector: 'app-access-denied',
    templateUrl: './access-denied.component.html',
    styleUrls: ['./access-denied.component.scss'],
})
export class AccessDeniedComponent implements OnInit {
    constructor(
        private tokenService: TokenService,
        private userService: UserService,
        private localStorage: LocalStorage
    ) {}

    ngOnInit(): void {
        this.localStorage.resetToken();
        this.localStorage.resetUser();
        this.userService.currentUser.next(null);
        setTimeout(() => {
            this.refreshToken();
        }, 600);
    }

    async refreshToken() {
        const response: any = await this.tokenService.refreshToken().toPromise();
        if (response.status_code === 0) {
            window.location.href = window.location.origin;
        }
    }
}
